import { useLocation } from 'react-router-dom'
import { fbt } from 'fbtee'
import { cn } from '@/lib/utils'
import { getNavTabs } from '@/lib/navTabs'
import { useTransitionNavigate } from '@/lib/viewTransition'
import { emitTabReselect } from '@/hooks/useTabReselect'
import { useCrewNavBadgeCount } from '../hooks/useCrewNavBadgeCount'

export function HeaderNav() {
  const location = useLocation()
  const navigate = useTransitionNavigate()
  const crewCount = useCrewNavBadgeCount()

  return (
    <nav className="hidden md:flex items-center gap-1" aria-label={fbt('Primary', 'Accessible label for the main header navigation landmark')}>
      {getNavTabs().map(tab => {
        const active = location.pathname === tab.to
        const badge = tab.to === '/social' ? crewCount : 0
        return (
          <button
            key={tab.to}
            type="button"
            onClick={() => {
              if (active) {
                emitTabReselect(tab.to)
                return
              }
              navigate(tab.to, { replace: true, direction: 'none' })
            }}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'relative px-3 py-1.5 rounded-md text-sm font-medium cursor-pointer transition-colors',
              active
                ? 'text-primary bg-primary/10'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted/60',
            )}
          >
            {tab.label}
            {badge > 0 && (
              <span data-testid="header-crew-badge" className="absolute top-0.5 right-0.5 min-w-4 h-4 px-1 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground text-[10px] font-semibold">
                {badge}
              </span>
            )}
          </button>
        )
      })}
    </nav>
  )
}
